import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { XeroService } from './xero.service';

angular.module('app-lite.xero', [])
  .service('xeroApi', downgradeInjectable(XeroService));
